import { Grid as ChakraGrid, Text } from '@chakra-ui/react';
import { ArrowInCircleUp } from '@time-line/components/icons';

interface VoteButtonProps {
  handleClick?: () => void;
  voteCount: number | null;
  isDisabled?: boolean;
  isDown?: boolean;
  hasVoted?: boolean;
}

export function VoteButton({
  handleClick,
  voteCount,
  isDisabled,
  hasVoted,
  isDown,
}: VoteButtonProps) {
  const isDisabledOrHasVoted = isDisabled || hasVoted;
  const optimisticVoteCount = hasVoted && voteCount === 0 ? 1 : voteCount;

  return (
    <ChakraGrid
      as="button"
      type="button"
      aria-label={isDown ? 'Downvote review' : 'Upvote review'}
      aria-pressed={hasVoted}
      disabled={isDisabledOrHasVoted}
      w="50px"
      h="24px"
      pr="5xs"
      pl="2px"
      bgColor={hasVoted ? 'gray.600' : 'transparent'}
      gridTemplateColumns="20px auto"
      alignItems="center"
      borderWidth={1}
      borderColor="blackAlpha.250"
      borderRadius="40px"
      onClick={!isDisabledOrHasVoted ? handleClick : undefined}
      _hover={{ cursor: isDisabledOrHasVoted ? 'auto' : 'pointer' }}
    >
      <ArrowInCircleUp
        color={
          (hasVoted && 'gray.50') ||
          (isDisabled && 'blackAlpha.500') ||
          'gray.600'
        }
        boxSize="20px"
        transform={isDown ? 'rotate(180deg)' : undefined}
      />
      <Text
        color={
          (hasVoted && 'gray.50') ||
          (isDisabled && 'blackAlpha.700') ||
          'gray.600'
        }
        fontSize="2xs-mono"
        textAlign="center"
        sx={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {optimisticVoteCount}
      </Text>
    </ChakraGrid>
  );
}
